<template>
  <div class="admin-tool-panel">
    <div class="row">
      <div class="col-2">
          <div class="text-center">
            <i :class="['far', icon, 'fa-5x', 'admin-tool-icon']" />
          </div>
      </div>
      <div class="col-10">
        <h3><strong>{{name}}</strong></h3>
        <p class="admin-tool-panel-description">{{description}}</p>
        <div class="row mt-2">
          <div class="col-12 text-right">
            <router-link class="btn btn-primary btn-outline" tag="a" :to="link"><i class="far fa-play-circle"> </i> Start</router-link>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.admin-tool-panel {
  background-color: #ffffff;
  border: 1px solid #e7eaec;
  padding: 20px;
  margin-bottom: 20px;
}
.admin-tool-panel-description {
  min-height: 50px;
  margin-bottom: 5px;
}
.admin-tool-icon {
  color: #A0A0A0;
  margin: auto 0;
}
</style>

<script>
export default {
  name: 'ToolPanel',
  props: {
    name: String,
    icon: String,
    link: String,
    description: String
  },
  data: () => {
    return {
    }    
  },
  methods: {
    
  }
}
</script>
